import React, { useState, useEffect } from "react";

import { Box, Typography, Paper, TableContainer } from "@mui/material";
import ChangePassword from "./ChangePassword"; // Assuming you have this component
import AdminUpdates from "./AdminUpdates"; // Assuming you have this component
import Funny from "./Funny";
import { StaffuseAuth } from "../../security/StaffuseAuth";
import ToDo from "./ToDo/ToDo";

const HomePage = () => {
  const { logout } = StaffuseAuth();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" }, // Change direction based on screen size
        justifyContent: "space-between",
        alignItems: "flex-start",
        p: 2,
        width: "97%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          p: 1,
          width: { xs: "100%", sm: "30%" }, // Adjust width based on screen size
          mb: { xs: 2, sm: 0 }, // Add margin bottom on small screens
        }}
      >
        <Funny />

        <br></br>
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            margin: "0 auto",
            maxHeight: 400,
            overflow: "auto",
          }}
        >
          <ChangePassword />
        </TableContainer>
        <br></br>
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            margin: "0 auto",
            maxHeight: 400,
            overflow: "auto",
          }}
        >
          <ToDo />
        </TableContainer>
      </Box>

      <Box
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: { xs: "100%", sm: "65%" }, // Adjust width based on screen size
        }}
      >
        <Typography variant="h6" gutterBottom>
          Admin Updates.
        </Typography>
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            margin: "0 auto",
            overflow: "auto",
          }}
        >
          <AdminUpdates />
        </TableContainer>
      </Box>
    </Box>
  );
};

export default HomePage;
